module.exports = __webpack_public_path__ + "e2ec6cb4b42ccd77a8f46c7b9d25c1c6.png";